
import React from 'react'
import { Helmet } from 'react-helmet'

import sc1 from '../assets/sc1.png'
import sc2 from '../assets/sc2.png'
import sc3 from '../assets/sc3.png'
import sc5 from '../assets/sc5.png'
import sc6 from '../assets/sc6.png'
import sc7 from '../assets/sc7.png'
import sc8 from '../assets/sc8.png'
import sc9 from '../assets/sc9.png'
import sc19 from '../assets/sc19.png'
import sc12 from '../assets/sc12.png'
import sc13 from '../assets/sc13.png'
import sc14 from '../assets/sc14.png'
import sc11 from '../assets/sc11.png'
import sc16 from '../assets/sc16.png'
import sc21 from '../assets/sc21.png'
import { FaGithub } from 'react-icons/fa'
import { FiExternalLink } from "react-icons/fi";


const projects = [
    {
        title: "Trash Detection Model",
        desc: "YOLO-based trash detection identifies and locates waste objects in real-time images or videos.",
        image: sc21,
        tech: ['Streamlit', 'Python', 'YOLO Model', 'Matplotlib', 'Numpy'],
        link: "https://github.com/Paresh-ch-Pothal/Trash-Detection-Using-YOLO"
    },
    {
        title: "Disease Prediction Model",
        desc: "A disease prediction model uses data to identify the risk of illness early, aiding faster diagnosis and treatment.",
        image: sc16,
        tech: ['Flask', 'Scikit-Learn', 'NLP', 'Pandas', 'Matplotlib', 'Numpy'],
        link: "https://github.com/Paresh-ch-Pothal/Disease-Prediction-System-Flask",
        live: "https://disease-prediction-sys.streamlit.app/"
    },
    {
        title: "Drag And Drop : Form Builder",
        desc: "Drag-and-drop form builder with customizable components, responsive design, and smooth element reordering.",
        image: sc19,
        tech: ['React', 'DND Kit', 'Tailwind CSS'],
        link: "https://github.com/Paresh-ch-Pothal/Drag-And-Drop-Form-Builder",
        live: "https://drag-and-drop-form-builder-red.vercel.app/"
    },
    {
        title: "TechXpert",
        desc: "TechXpert is a platform to teach, learn, track progress, earn certificates, and collaborate.",
        image: sc11,
        tech: ['React', 'Node.js', 'Express', 'MongoDB', 'html2canvas', 'jspdf'],
        link: "https://github.com/Paresh-ch-Pothal/TechXpert",
        live: ""
    },
    {
        title: "Anubandh",
        desc: "Anubandh is an alumni networking system that connects alumni and current students, fostering collaboration and mentorship.",
        image: sc12,
        tech: ["React", "Node.js", "Express", "MongoDB"],
        link: "https://github.com/Paresh-ch-Pothal/Anubandh",
        live: ""
    },
    {
        title: "Code Compiler",
        desc: "Code Compiler is an online platform that allows users to compile and run HTML, CSS, and JavaScript files in real-time.",
        image: sc13,
        tech: ["React", "monaco-editor"],
        link: "https://github.com/Paresh-ch-Pothal/Code-Complier",
        live: "https://code-complier-rosy.vercel.app/"
    },
    {
        title: "E-Commerce Website",
        desc: "The E-commerce website, built with Next.js, delivers fast, responsive shopping experiences and dynamic content.",
        image: sc14,
        tech: ["React", "Node.js", "Express", "MongoDB"],
        link: "https://github.com/Paresh-ch-Pothal/E-Commerce",
        live: ""
    },
    {
        title: "Juris Spectra",
        desc: "Juris Spectra is a MERN stack website providing law students with daily news and internship opportunities.",
        image: sc1,
        tech: ["React", "Node.js", "Express", "MongoDB"],
        link: "https://github.com/Paresh-ch-Pothal/Juris-Spectra",
        live: "https://juris-spectra-ir7b.vercel.app/"
    },
    {
        title: "Chat-App",
        desc: "Chat-app built using the MERN stack and Socket.IO, offers real-time messaging and seamless communication.",
        image: sc2,
        tech: ["React", "Node.js", "Express", "MongoDB", "Socket.IO"],
        link: "https://github.com/Paresh-ch-Pothal/Chat-App",
        live: ""
    },
    {
        title: "Food Store",
        desc: "A food-store website developed with MERN stack, providing a seamless shopping experience for food products.",
        image: sc3,
        tech: ["React", "Node.js", "Express", "MongoDB"],
        link: "https://github.com/Paresh-ch-Pothal/Food-Store",
        live: ""
    },
    {
        title: "iNotebook",
        desc: "iNotebook offers digital note-taking, built using the MERN stack for robust functionality and sleek interface.",
        image: sc5,
        tech: ["React", "Node.js", "Express", "MongoDB"],
        link: "https://github.com/Paresh-ch-Pothal/iNotebook",
        live: ""
    },
    {
        title: "Weather App",
        desc: "Weather app using API provides real-time updates with React.js and modern UI.",
        image: sc6,
        tech: ["React", "HTML", "Weather API", "CSS"],
        link: "https://github.com/Paresh-ch-Pothal/Weather-App",
        live: ""
    },
    {
        title: "Calculator",
        desc: "A simple calculator built using HTML, CSS, and JavaScript for basic arithmetic operations.",
        image: sc7,
        tech: ["HTML", "CSS", "Javascript"],
        link: "https://github.com/Paresh-ch-Pothal/Calculator",
        live: ""
    },
    {
        title: "Netflix Clown",
        desc: "A Netflix clone created using HTML and CSS to replicate the streaming UI.",
        image: sc8,
        tech: ["HTML", "CSS"],
        link: "https://github.com/Paresh-ch-Pothal/Netflix-Clone",
        live: ""
    },
];

const getRandomColor = () => {
    const colors = [
        'bg-blue-500', 'bg-green-500', 'bg-yellow-500', 'bg-purple-500',
        'bg-red-500', 'bg-pink-500', 'bg-indigo-500', 'bg-teal-500',
        'bg-gray-500', 'bg-yellow-400',
    ];
    return colors[Math.floor(Math.random() * colors.length)];
};

const Project = () => {
    return (
        <div>
            <Helmet>
                <title>Projects | Paresh Chandra Pothal</title>
                <meta name="description" content="Explore the projects developed by Paresh Chandra Pothal, showcasing skills in AI, Machine Learning, and Full-Stack Development." />
                <meta name="keywords" content="projects, Paresh Chandra Pothal, AI, Machine Learning, Full-Stack Development, portfolio, web development" />
                <meta name="author" content="Paresh Chandra Pothal" />
            </Helmet>

            <section style={{ backgroundColor: "rgba(21, 21, 21, 1)" }} className="text-gray-40 body-font">
                <div className="container px-5 py-24 mx-auto">
                    <div className="flex flex-col text-center w-full mb-20">
                        <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-white">My Projects</h1>
                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base text-white">
                            Creating projects bridges the gap between theory and practice, turning abstract ideas into functional solutions. It fosters creativity, hones problem-solving skills, and provides hands-on experience, making learning more dynamic and impactful while preparing you for real-world challenges.
                        </p>
                    </div>

                    <div className="flex flex-wrap -m-4">
                        {projects.map((project, index) => (
                            <div key={index} className="lg:w-1/3 sm:w-1/2 p-4">
                                <div className="flex relative">
                                    <img alt="gallery" className="absolute inset-0 w-full h-full object-cover object-center" src={project.image} />
                                    <div className="px-8 py-10 relative z-10 w-full border-4 border-gray-800 bg-gray-800 opacity-0 hover:opacity-100">
                                        <h1 className="title-font text-lg font-medium text-green-400 mb-3">{project.title}</h1>
                                        <p className="leading-relaxed text-white">{project.desc}</p>
                                        <div className="flex flex-wrap mt-2">
                                            {project.tech.map((tech, idx) => (
                                                <span key={idx} className={`${getRandomColor()} text-white text-xs font-bold py-1 px-2 rounded-full mr-2 mb-2`}>
                                                    {tech}
                                                </span>
                                            ))}
                                        </div>
                                        <div className="py-1 flex space-x-4 items-center">
                                            <a
                                                href={project.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="flex items-center text-white"
                                            >
                                                <FaGithub className="mr-1" />
                                                GitHub
                                            </a>

                                            {project.live && (
                                                <a
                                                    href={project.live}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="flex items-center text-white"
                                                >
                                                    <FiExternalLink className="mr-1" />
                                                    Live Preview
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
        </div>
    );
};

export default Project;
